// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PersonSearch48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PersonSearch48: FC<PersonSearch48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
            viewBox="0 0 48 48"
        >
            <path d="M22.025 23Q18.9 23 16.7 20.797q-2.2-2.204-2.2-5.297 0-3.15 2.203-5.325Q18.907 8 22 8q3.15 0 5.325 2.175t2.175 5.3-2.175 5.325-5.3 2.2M22 20q1.9 0 3.2-1.322 1.3-1.321 1.3-3.178 0-1.9-1.3-3.2T22.025 11t-3.2 1.3-1.325 3.175 1.322 3.2T22 20m22.9 27-7-7q-1.15.85-2.375 1.175a9.7 9.7 0 0 1-2.503.325q-3.551 0-6.036-2.481-2.487-2.48-2.486-6.025 0-3.544 2.481-6.019t6.025-2.475 6.019 2.485 2.475 6.037a9.7 9.7 0 0 1-.325 2.503Q40.85 36.75 40 37.9l7 7zm-7.975-10.075Q38.5 35.35 38.5 33t-1.575-3.925T33 27.5t-3.925 1.575T27.5 33t1.575 3.925T33 38.5t3.925-1.575M6 40v-4.7q0-1.85.875-3.15T9.4 30q2.35-1.15 6.125-2.175a23.4 23.4 0 0 1 7.675-.775 13 13 0 0 0-.75 1.425A10 10 0 0 0 21.9 30q-3.9-.05-6.8.925T10.6 32.7a3.4 3.4 0 0 0-1.15 1.075Q9 34.45 9 35.3V37h12.9q.55.85 1 1.575.45.724 1 1.425z" />
        </svg>
    );
};

export default PersonSearch48;
